import React, { useEffect, useState } from 'react'
import LiveChatLoginComponent from './live-chat-popup-login.component';
import LiveChatConversationComponent from './live-chat-popup-conversation.component';
import { ChannelType, LiveChatStatus, LiveChatUserLoggedInStatus } from '../../models/conversations';
import { LiveChatService } from '../../services/channels/LiveChatService';
import { UtilityService } from '../../services/UtilityService';
import AnimateLoaderComponent from '../shared/loaders/animate-loader.component';
import livechatPageLoader from "../shared/loaders/live-chat-page-loader.json";
import { useLocation, useParams } from 'react-router';
import { ChannelService } from '../../services/channels/ChannelAcountService';
import { VisitorLoginType, WidgetTitle } from '../../models/channels/channels.model';

interface IProps {
    ChannelId?: string;
    IsMobile?: boolean;
}

const LiveChatComponent: React.FC<IProps> = (props: IProps) => {
    const { channelId, isMobile } = useParams()

    const ShareToChatLink = useLocation().pathname.includes("share-to-chat-link");

    const ChannelId = channelId ? channelId : props.ChannelId;

    const IsMobileDevice = isMobile ? isMobile === "true" ? true : false : props.IsMobile;

    const [UserLoggedInStatus, setUserLoggedInStatus] = useState<number>(LiveChatUserLoggedInStatus.CheckingStatus);
    const [userId, setUserId] = useState<string>("")
    const [title, setTitle] = useState<string>("")
    const [icon, setIcon] = useState<string>("")
    const [latestSession, setLatestSession] = useState<number>(0)
    const [deviceID, setDevicelId] = useState<string>("")
    const [channelStatus, setChannelStatus] = useState<LiveChatStatus>(null);
    const [validatedUrl, setValidatedUrl] = useState<string>("");
    const [isLogedUser, setIsLogedUser] = useState<boolean>(false)
    const [soundsEnabled, setSoundsEnabled] = useState<boolean>(false)
    const [isOrgnizationActive, setIsOrgnizationActive] = useState<boolean>(false)
    const [conversationStatus, setConversationStatus] = useState<number>(1)
    const [showRating, setShowRating] = useState<boolean>(false)
    const [livechatTheme, setLivechatTheme] = useState<string>("")
    const [visitorLoginType, setVisitorLoginType] = useState<number>(1)
    const [facebookUrl, setFacebookUrl] = useState<string>("")
    const [whatsappUrl, setWhatsappUrl] = useState<string>("")
    const [customLoginFields, setCustomLLoginFeilds] = useState<any[]>([])
    const [falkonBranding, setFalkonBranding] = useState<boolean>(true);
    const [includeQuestionarrie, setIncludeQuestionarrie] = useState<boolean>(true);
    const [widgetType, setWidgetType] = useState<number>(1)
    const [welcomeMessage, setWelcomeMessage] = useState<string>("");
    const [headerTextColor, setHeaderTextColor] = useState<string>("#0F0F0F");
    const [isPremiumPlan, setIsPremiumPlan] = useState<boolean>(true);


    useEffect(() => {
        if (!deviceID) {
            setDevicelId(getOrCreateDeviceId())
        }
    }, [])

    useEffect(() => {
        LiveChatService.GetLiveChatDetails(ChannelId).then((res) => {
            setIsPremiumPlan(res.data?.is_premium)
            setTitle(res.data.channel_name)
            setIcon(res.data.channel_icons)
            setValidatedUrl(res.data.validated_url)
            setLivechatTheme(!res.data?.is_premium ? "linear-gradient(65deg, rgb(20, 80, 255) 50%, rgb(10, 40, 128) 90%)" : res.data.premium_features.widget_color)
            setVisitorLoginType(!res.data?.is_premium ? VisitorLoginType.ALLOW_LOGIN_AND_ANONYMOUS_LOGIN : res.data.premium_features.visitor_login_type)
            setCustomLLoginFeilds(!res.data?.is_premium ? [] : res.data.premium_features.login_fields)
            setFalkonBranding(!res.data?.is_premium ? true : res.data.premium_features.isAllowFalkonBranding)
            setIncludeQuestionarrie(!res.data?.is_premium ? false : res.data.premium_features.isIncludeQuestionnaire)
            setWidgetType(!res.data?.is_premium ? WidgetTitle.NAME_AND_LOGO : res.data.premium_features.widget_type)
            setWelcomeMessage(res.data.welcome_message)
            setFacebookUrl(!res.data?.is_premium ? "" : res.data.premium_features.channels?.find(x => x.channel_type === ChannelType.FACEBOOK)?.url)
            setWhatsappUrl(!res.data?.is_premium ? "" : res.data.premium_features.channels?.find(x => x.channel_type === ChannelType.WHATSAPP)?.url)
            setHeaderTextColor(!res.data?.is_premium ? "#0F0F0F" : res.data.premium_features.text_color)
            ChannelService.GetBusinessActiveStatus(res.data.organization_id, 4).then((res) => {
                setIsOrgnizationActive(res.data.business_active)
            }).catch(err => { })
            LiveChatService.GetLiveChatStatus({ channelid: ChannelId }).then((res) => {
                setChannelStatus(res.data.ChannelAccountStatusResult)
            }).catch(err => { })
        }).catch(err => { })
    }, [])


    useEffect(() => {
        if (!!deviceID) {
            LiveChatService.GetClientToken(deviceID)
                .then((response) => {

                    const userToken = {
                        access_token: response.data, // Use response.data here
                    };

                    // Convert the object to JSON string
                    const tokenJSON = JSON.stringify(userToken);

                    // Set user-token to localStorage
                    localStorage.setItem('livechat-token', tokenJSON);
                })
                .catch((error) => {
                });
        }
    }, [deviceID]);

    useEffect(() => {
        if (ChannelId && deviceID && !userId) {
            LiveChatService.CheckLiveChatActiveUser(ChannelId, deviceID).then(res => {
                if (res) {
                    setUserId(res.data.id)
                    setLatestSession(new Date(res.data.latest_session).getTime());
                    setUserLoggedInStatus(new Date(res.data.latest_session).getTime() ? LiveChatUserLoggedInStatus.LoggedIn : LiveChatUserLoggedInStatus.LoggedOut)
                    setIsLogedUser(res.data.username === "Anonymous_User" ? false : true)
                    setSoundsEnabled(res.data.sound_enabled)
                    setConversationStatus(res.data.ticket.status)
                }
            }).catch(err => {
                setUserLoggedInStatus(LiveChatUserLoggedInStatus.LoggedOut)
            })
        }
    }, [deviceID])


    // Function to generate or retrieve a persistent device ID using local storage
    const getOrCreateDeviceId = () => {
        const deviceId = localStorage.getItem("device_id");

        if (deviceId) {
            return deviceId;
        } else {
            const newDeviceId = generateDeviceId();
            localStorage.setItem("device_id", newDeviceId);
            return newDeviceId;
        }
    };

    // Function to generate a unique device ID
    const generateDeviceId = () => {
        // Generate a random identifier
        const randomId = Math.random().toString(36).substring(2, 15) +
            Math.random().toString(36).substring(2, 15);

        // Combine device-specific attributes for added uniqueness
        const combinedInfo = navigator.userAgent + window.screen.width + window.screen.height + window.devicePixelRatio;

        // Hash the combined information to create a device ID
        const deviceId = hashString(combinedInfo);

        // Combine the random identifier with the hashed device ID
        return `${randomId}_${deviceId}`;
    };

    // Function to hash a string using a simple hash algorithm
    const hashString = (input) => {
        let hash = 0;
        for (let i = 0; i < input.length; i++) {
            const char = input.charCodeAt(i);
            hash = ((hash << 5) - hash) + char;
        }
        return hash.toString(36); // Convert the hash to a base36 string
    };

    const handleUserData = (userId, latestSession, isLogedUser, sounds) => {
        setUserId(userId);
        setLatestSession(latestSession);
        setIsLogedUser(isLogedUser)
        setSoundsEnabled(sounds)
        setShowRating(false)
        setUserLoggedInStatus(LiveChatUserLoggedInStatus.LoggedIn)
    }

    const handleEndChat = () => {
        setUserLoggedInStatus(LiveChatUserLoggedInStatus.LoggedOut)
        setUserId("")
        setLatestSession(0)
    }

    const handleChannelStatus = () => {
        setChannelStatus(LiveChatStatus.DISCONNECTED)
    }

    return (
        <div className="w-p-100 h-p-100 bg-transparent">
            <div className="w-p-100 h-p-100 p-fixed o-y-auto">
                {(UserLoggedInStatus === LiveChatUserLoggedInStatus.CheckingStatus || !channelStatus) &&
                    <div className="h-p-100 d-flex align-center justify-center o-hidden">
                        <AnimateLoaderComponent LoaderAnimation={livechatPageLoader} className={"w-p-100"} />
                    </div>
                }

                {!!channelStatus && (channelStatus !== LiveChatStatus.CONNECTED || UserLoggedInStatus === LiveChatUserLoggedInStatus.LoggedOut) &&
                    <LiveChatLoginComponent ChannelId={ChannelId} Title={title} DeviceId={deviceID} HandleUserData={handleUserData} Icon={icon} ChannelStatus={channelStatus} IsMobile={IsMobileDevice} ValidatedUrl={validatedUrl} IsShareToChatLink={ShareToChatLink} IsOrgnizationActive={isOrgnizationActive} LiveChatTheme={livechatTheme} VisitorLoginType={visitorLoginType} CustomLoginFeilds={customLoginFields} FalkonBranding={falkonBranding} WidgetType={widgetType} WelcomeMessage={welcomeMessage} FaceBookUrl={facebookUrl} WhatsappUrl={whatsappUrl} HeaderTextColor={headerTextColor} />
                }

                {!!channelStatus && channelStatus === LiveChatStatus.CONNECTED && UserLoggedInStatus === LiveChatUserLoggedInStatus.LoggedIn &&
                    <LiveChatConversationComponent ChannelId={ChannelId} Title={title} DeviceId={deviceID} UserID={userId} LatestSession={latestSession} handleEndChat={handleEndChat} handleChannelStatus={handleChannelStatus} Icon={icon} IsMobile={IsMobileDevice} ValidatedUrl={validatedUrl} IsLogedUser={isLogedUser} IsShareToChatLink={ShareToChatLink} Sounds={soundsEnabled} IsOrgnizationActive={isOrgnizationActive} ConversationStatus={conversationStatus} SetShowRating={() => setShowRating(true)} ShowRating={showRating} FalkonBranding={falkonBranding} LivechatTheme={livechatTheme} IncludeQuestionarrie={includeQuestionarrie} WidgetType={widgetType} FaceBookUrl={facebookUrl} WhatsappUrl={whatsappUrl} HeaderTextColor={headerTextColor} />
                }
            </div>
        </div>
    )
}

export default LiveChatComponent;